import { Reveal } from "./Reveal";
import { WaButton } from "./WhatsAppIcon";
import { SECTION_IDS, WA_DEFAULT_LINK, CNPJ, ADDRESS, HOURS, WHATSAPP_DISPLAY } from "../constants/site";
import { MapPin, Clock, ShieldCheck, Phone } from "lucide-react";

const ABOUT_IMG =
    "https://images.pexels.com/photos/38190070/pexels-photo-38190070.jpeg?auto=compress&cs=tinysrgb&w=1000";

const INFO = [
    { icon: ShieldCheck, label: "CNPJ", value: CNPJ, testId: "about-info-cnpj" },
    { icon: MapPin, label: "Endereço", value: ADDRESS, testId: "about-info-address" },
    { icon: Clock, label: "Horários", value: HOURS, testId: "about-info-hours" },
    { icon: Phone, label: "WhatsApp", value: WHATSAPP_DISPLAY, testId: "about-info-phone" },
];

export const About = () => (
    <section id={SECTION_IDS.sobre} className="scroll-mt-24 bg-white py-20 sm:py-28" data-testid="about-section">
        <div className="mx-auto max-w-7xl px-5 sm:px-8 grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
            <Reveal className="relative order-2 lg:order-1" y={36}>
                <div className="relative max-w-md mx-auto lg:max-w-none">
                    <div
                        className="absolute inset-0 translate-x-4 translate-y-4 rounded-[2rem] border-2 border-brand/50"
                        aria-hidden="true"
                    />
                    <img
                        src={ABOUT_IMG}
                        alt="Técnico da Refrigelar examinando eletrodoméstico em oficina"
                        loading="lazy"
                        className="relative w-full aspect-[4/5] object-cover rounded-[2rem] shadow-[0_30px_60px_-25px_rgba(48,52,58,0.4)]"
                    />
                </div>
            </Reveal>

            <div className="order-1 lg:order-2">
                <Reveal>
                    <p className="font-technical font-semibold uppercase tracking-[0.2em] text-sm text-brand">
                        Sobre a Refrigelar
                    </p>
                    <h2 className="mt-3 font-display font-black tracking-tight text-3xl sm:text-5xl text-graphite leading-tight">
                        Especialistas em geladeiras em Uberlândia
                    </h2>
                    <p className="mt-5 text-base sm:text-lg text-graphite/70 leading-relaxed max-w-lg">
                        A REFRIGELAR faz conserto de geladeiras e lava e secas com diagnóstico preciso e atendimento
                        direto pelo WhatsApp — do primeiro contato ao reparo final, sem enrolação.
                    </p>
                </Reveal>

                <Reveal delay={0.1}>
                    <ul className="mt-8 space-y-4">
                        {INFO.map(({ icon: Icon, label, value, testId }) => (
                            <li
                                key={label}
                                data-testid={testId}
                                className="flex items-center gap-4 rounded-2xl bg-fog border border-mist px-5 py-3.5"
                            >
                                <span className="inline-flex items-center justify-center w-10 h-10 rounded-xl bg-brand/10 text-brand shrink-0">
                                    <Icon className="w-5 h-5" />
                                </span>
                                <div className="min-w-0">
                                    <p className="font-technical font-semibold uppercase tracking-[0.14em] text-[11px] text-graphite/50">
                                        {label}
                                    </p>
                                    <p className="font-display font-semibold text-sm sm:text-base text-graphite truncate">
                                        {value}
                                    </p>
                                </div>
                            </li>
                        ))}
                    </ul>
                </Reveal>

                <Reveal delay={0.15}>
                    <div className="mt-9">
                        <WaButton href={WA_DEFAULT_LINK} testId="about-whatsapp-cta">
                            Solicitar atendimento pelo WhatsApp
                        </WaButton>
                    </div>
                </Reveal>
            </div>
        </div>
    </section>
);
